/** Alternate images returned per page of a character or worldbuilding image gallery. */
export const ENTITY_IMAGES_PAGE_SIZE = 24;

/** Longest free-text description the image dialog accepts; the server trims anything longer. */
export const MAX_IMAGE_DESCRIPTION_LENGTH = 2500;

/** Maximum size of a user-uploaded image or generation reference image. */
export const ENTITY_IMAGE_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;

// Generated images are uncapped because each one already costs credits.
export const MAX_USER_UPLOADED_IMAGES_PER_ENTITY = 100;
